import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { BRAND } from "@/lib/site";

const POSITION = [-31.94195, 115.85493];

const pin = L.divIcon({
  className: "",
  html: `
    <div class="tempa-pin">
      <span class="tempa-pin__pulse"></span>
      <span class="tempa-pin__dot"></span>
      <span class="tempa-pin__label">TEMPA</span>
    </div>
  `,
  iconSize: [0, 0],
});

export const DarkMap = () => (
  <div data-testid="location-map" className="relative h-full min-h-[360px] lg:min-h-[480px] border border-line overflow-hidden">
    <MapContainer
      center={POSITION}
      zoom={15}
      scrollWheelZoom={false}
      className="absolute inset-0 z-0"
      style={{ background: "#050505" }}
    >
      <TileLayer
        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <Marker position={POSITION} icon={pin} />
    </MapContainer>

    {/* vignette so the map melts into the page */}
    <div className="pointer-events-none absolute inset-0 z-[400] shadow-[inset_0_0_80px_40px_rgba(5,5,5,0.85)]" aria-hidden="true" />

    {/* address chip */}
    <div className="absolute bottom-4 left-4 z-[500] border border-line bg-ink/85 backdrop-blur-md px-5 py-4">
      <p data-testid="map-address" className="font-display text-lg text-cream">299 Fitzgerald Street</p>
      <p className="mt-0.5 text-xs tracking-[0.2em] uppercase text-stone2">West Perth · WA 6005</p>
      <a
        data-testid="map-directions-link"
        href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(BRAND.address)}`}
        target="_blank"
        rel="noreferrer"
        className="mt-3 inline-block text-xs tracking-[0.2em] uppercase font-medium text-ember hover:text-rust transition-colors"
      >
        Get directions →
      </a>
    </div>
  </div>
);
